import Textarea from "@atlaskit/textarea";
import type {ComponentProps} from "react";

export function AnankeTextArea(props: ComponentProps<typeof Textarea>) {
    return <Textarea {...props} />;
}
